export const regrasDeNegocio = {
    LIMITE_REPROVACOES: 2,
    LIMITE_ASSINATURAS_MIN: 1,
    LIMITE_ASSINATURAS_MAX: 3
}